import { useCallback } from "react";
import { useLazyGetPdfDocumentQuery } from "../../../document/store/documentApi";
import { PDF_MIME_TYPE } from "../../../document/constants";
import { resolveMimeType } from "../../../document/utils/mimeType";

const useDownloadPdf = () => {
  const [getPdfDocument] = useLazyGetPdfDocumentQuery();

  return useCallback(
    async (id: string, fileName: string, mimeType?: string | null) => {
      try {
        const data = await getPdfDocument(id).unwrap();
        // The endpoint is called /pdf for backwards compatibility but serves whatever the
        // document is. Labelling a PNG as a PDF opens the wrong application; falling back
        // to PDF keeps the historical answer when nothing identifies the file.
        const type =
          resolveMimeType({ name: fileName, mimeType }) ?? PDF_MIME_TYPE;
        const blob = new Blob([data], { type });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        return true;
      } catch (error) {
        console.error(error);
        return false;
      }
    },
    [getPdfDocument],
  );
};

export default useDownloadPdf;
